import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { useTranslation } from 'react-i18next';

import { loginAtom } from '../../../lib/auth';

import {
  Button as Btn,
  Checkbox,
  DialogActions,
  Grid,
  MenuItem,
  useMediaQuery,
} from '@mui/material';

import {
  DatePicker,
  Editor,
  Select,
  Switcher,
  TextInput,
  Typography
} from '../../../components/v2/styled';
import { Base } from './Base';

import { FoodEntry } from '../../../models/FoodEntry';
import { Medication } from '../../../models/Medication';

const { DateTime } = require("luxon");

type Props = {
  onClick: () => void;
  open: boolean;
  setOpen: (b:boolean) => void;
  medication: Medication;
  setMedication: (n:Medication) => void;
  asPractice?: boolean;
  editableAsPractice?: boolean;
};

export const ClientMsboEdit: FunctionComponent<Props> = ({open, setOpen, onClick, medication, setMedication, asPractice, editableAsPractice}) => {
  const theme = useTheme();
  // const navigate = useNavigate();
  const [login, setLogin] = useAtom(loginAtom);
  const {t, i18n} = useTranslation(['translations']);

  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const [currentTab, setCurrentTab] = useState<string>((Object.values(login?.full_eat_groups || {}).filter(fff => fff.practices.length > 0).length > 0 ? 'eat_diary.groups.short' : 'eat_diary.groups.everything'));
  const [errors, setErrors] = useState<{[z:string]: string}>({});
  const [editing, setEditing] = useState<number>();
  const [newFoodEntry, setNewFoodEntry] = useState<FoodEntry>({entry: '', comment: ''});
  const [showMedEnd, setShowMedEnd] = useState<boolean>(false);
  const [flickerEditor, setFlickerEditor] = useState<boolean>(false);
// console.log(login?.full_eat_groups);
// console.log(DateTime.now().toFormat("t"));




  useEffect(() => {
    setShowMedEnd(!!medication.med_end);
  }, [medication]);



  return (<>
    <Base
      name="msbo_edit"
      title={`${t("client.dashboard.msbo.new_entry_title", "Nieuwe ingave")}`}
      fullWidth
      onClose={() => {
        setMedication({name: ''});
      }}
      fullScreen={fullScreen}
      maxWidth="lg"
      content={<>
      
        <Grid item xs={12} container spacing={1}>
          <Grid item xs={12} md={6}>
            <Typography variant="caption">{t("client.models.medications.med_start")}*</Typography><br/>
            <DatePicker
              disableFuture={false}
              shouldDisableDate={() => ((!asPractice && !!medication.practice_id) || (!!asPractice && !editableAsPractice))}
              openTo="year"
              label=""
              format={"dd/LL/y"}
              views={["year", "month", "day"]}
              setValue={(e) => {
                setMedication({
                  ...(medication || {}),
                  med_start: e,
                  med_end: e
                });
              }}
              value={medication.med_start || DateTime.now().toFormat("dd/LL/y")}
              id="option_date"
              sx={{
                box: {
                  width: 'auto',
                  display: 'inline-block'
                },
                field_box: {
                  "svg": {
                    display: 'none'
                  }
                },
                field: {
                  width: 'auto',
                  marginTop: 0,
                  "input": {
                    textAlign: 'center'
                  }
                }
              }}
            />
          </Grid>
          <Grid item xs={12} md={2}>
            <Typography variant="caption">{t("client.models.medications.has_med_end")}</Typography><br/>
            <Checkbox checked={!!showMedEnd}
              disabled={(!asPractice && !!medication.practice_id) || (!!asPractice && !editableAsPractice)}
              onChange={(e) => {
              if (e.target.checked) {
                setShowMedEnd(true);
                setMedication({
                  ...(medication || {}),
                  med_end: DateTime.now().toFormat("dd/LL/y")
                });
              } else {
                setShowMedEnd(false);
                setMedication({
                  ...(medication || {}),
                  med_end: undefined
                });
              }
            }} />
          </Grid>
          <Grid item xs={12} md={4}>
            {!!showMedEnd && <Typography variant="caption">{t("client.models.medications.med_end")}</Typography>}
            <br/>
            {!!showMedEnd && <DatePicker
              disableFuture={false}
              shouldDisableDate={() => ((!asPractice && !!medication.practice_id) || (!!asPractice && !editableAsPractice))}
              openTo="year"
              label=""
              format={"dd/LL/y"}
              views={["year", "month", "day"]}
              setValue={(e) => {
                setMedication({
                  ...(medication || {}),
                  med_end: e
                });
              }}
              value={medication.med_end || DateTime.now().toFormat("dd/LL/y")}
              id="option_date"
              sx={{
                box: {
                  width: 'auto',
                  display: 'inline-block'
                },
                field_box: {
                  "svg": {
                    display: 'none'
                  }
                },
                field: {
                  width: 'auto',
                  marginTop: 0,
                  "input": {
                    textAlign: 'center'
                  }
                }
              }}
            />}
          </Grid>
          <Grid item xs={12}>
            <TextInput
              id="name"
              required
              starred
              disabled={(!asPractice && !!medication.practice_id) || (!!asPractice && !editableAsPractice)}
              caption={t("client.models.medications.name")}
              placeholder={t("client.models.medications.placeholders.name")}
              value={medication?.name || ""}
              onChange={(e) => {
                setMedication({
                  ...(medication || {}),
                  name: e
                });
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Select
              fullWidth
              displayEmpty
              disabled={(!asPractice && !!medication.practice_id) || (!!asPractice && !editableAsPractice)}
              caption={t("client.models.medications.med_type")}
              id="med_type"
              value={medication?.med_type?.toLowerCase() || ''}
              setValue={(v) => {
                setMedication({
                  ...(medication || {}),
                  med_type: v?.toString()
                });
              }}
            >
              <MenuItem value="">--- ---</MenuItem>
              <MenuItem value="complaint">{t("client.models.medications.med_types.complaint")}</MenuItem>
              <MenuItem value="important_event">{t("client.models.medications.med_types.important_event")}</MenuItem>
              <MenuItem value="diet">{t("client.models.medications.med_types.diet")}</MenuItem>
              <MenuItem value="medicatie">{t("client.models.medications.med_types.medication")}</MenuItem>
              <MenuItem value="supplement">{t("client.models.medications.med_types.supplement")}</MenuItem>
              <MenuItem value="treatment">{t("client.models.medications.med_types.treatment")}</MenuItem>
              <MenuItem value="operation">{t("client.models.medications.med_types.operation")}</MenuItem>
              <MenuItem value="research">{t("client.models.medications.med_types.research")}</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={12} md={6}>
            <Switcher
              id="doctor_note"
              disabled={(!asPractice && !!medication.practice_id) || (!!asPractice && !editableAsPractice)}
              caption={t("client.models.medications.doctor_note")}
              value={!!medication?.doctor_note}
              onChange={(c) => {
                setMedication({
                  ...(medication || {}),
                  doctor_note: !!c
                });
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            {!flickerEditor && <Editor
              advanced
              label={t("client.models.medications.cause")}
              disabled={(!asPractice && !!medication.practice_id) || (!!asPractice && !editableAsPractice)}
              value={medication?.cause || ""}
              outside_world={!!asPractice}
              onChange={(e) => {
                setMedication({
                  ...(medication || {}),
                  cause: e
                });
              }}
            />}
          </Grid>
          <Grid item xs={12} md={6}>
            {!flickerEditor && <Editor
              advanced
              label={t("client.models.medications.med_interval")}
              disabled={(!asPractice && !!medication.practice_id) || (!!asPractice && !editableAsPractice)}
              value={medication?.med_interval || ""}
              outside_world={!!asPractice}
              onChange={(e) => {
                setMedication({
                  ...(medication || {}),
                  med_interval: e
                });
              }}
            />}
          </Grid>
          <Grid item xs={12} md={6}>
            {!flickerEditor && <Editor
              advanced
              label={t("client.models.medications.comment")}
              disabled={(!!asPractice && !editableAsPractice)}
              value={medication?.comment || ""}
              outside_world={!!asPractice}
              onChange={(e) => {
                setMedication({
                  ...(medication || {}),
                  comment: e
                });
              }}
            />}
          </Grid>
          {!!asPractice && !!editableAsPractice && <Grid item xs={12} md={6}>
            {!flickerEditor && <Editor
              advanced
              label={t("client.models.medications.internal_comment")}
              value={medication?.internal_comment || ""}
              onChange={(e) => {
                setMedication({
                  ...(medication || {}),
                  internal_comment: e
                });
              }}
            />}
          </Grid>}
          {!!asPractice && !editableAsPractice && <Grid item xs={12} md={6}>
            {!flickerEditor && <Editor
              advanced
              label={t("client.models.medications.public_comment")}
              value={medication?.get_public_comment || ""}
              onChange={(e) => {
                setMedication({
                  ...(medication || {}),
                  get_public_comment: e
                });
              }}
            />}
          </Grid>}
        </Grid>

      </>}
      actions={<DialogActions sx={{borderTop: '1px solid transparent', borderColor: theme.palette.primary.main}}>
        <Btn
          onClick={(e) => {
            setMedication({name: ''});
            setOpen(false);
          }}
          color="primary"
        >{t("coach.general.actions.close")}</Btn>
        <Btn
          onClick={onClick}
          color="primary"
          disabled={!medication?.name || !medication?.med_start}
        >{t("coach.general.actions.save")}</Btn>
      </DialogActions>}
      open={open}
      setOpen={setOpen}
    />
  </>);
}
